import type { ContractPartDescriptionSource } from '../../lib/api';

/**
 * Customer review 11 Sep (items 22 + 29): the tooltip on a contract part's
 * Description cell when the text is not the part's own — the API fills a blank
 * description from the part master, then the latest PO line for the part.
 *
 * Shared by Contract Details > Contract Parts and the PO line Pricebooks tab so
 * the two surfaces explain the same text the same way.
 *
 * @param source - `description_source` from the API
 * @returns the tooltip, or undefined when the contract part holds the text itself
 */
export function descriptionHint(source?: ContractPartDescriptionSource): string | undefined {
  if (source === 'part_master') {
    return 'From the part master — this contract part has no description of its own';
  }
  if (source === 'po_line') {
    return 'From the latest PO line for this part — the part master has no description';
  }
  return undefined;
}
